import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function TermsOfService() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar scrolled={true} />
      
      <div className="pt-32 pb-16 px-6">
        <div className="max-w-4xl mx-auto">
          <div className="mb-12">
            <h1 className="text-5xl font-bold text-[#0A381F] mb-4">Terms of Service</h1>
            <p className="text-gray-600 text-lg">Last updated: January 2025</p>
          </div>

          <div className="prose prose-lg max-w-none">
            <section className="mb-12">
              <h2 className="text-3xl font-bold text-[#0A381F] mb-4">1. Acceptance of Terms</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Welcome to MoveToIreland.us. By accessing or using our platform, you agree to be bound by these Terms of Service ("Terms"). 
                If you do not agree to these Terms, please do not use our services.
              </p>
              <p className="text-gray-700 leading-relaxed">
                These Terms constitute a legally binding agreement between you and MoveToIreland.us. We reserve the right to modify these Terms at any time, 
                and your continued use of the platform constitutes acceptance of any changes.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-3xl font-bold text-[#0A381F] mb-4">2. Description of Services</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                MoveToIreland.us is a platform that connects individuals relocating to Ireland with verified service providers, including but not limited to:
              </p>
              <ul className="list-disc pl-6 mb-4 space-y-2 text-gray-700">
                <li>Immigration lawyers and consultants</li>
                <li>Real estate agents and housing services</li>
                <li>Moving and logistics companies</li>
                <li>Pet relocation services</li>
                <li>Financial and tax advisors</li>
                <li>Healthcare providers</li>
                <li>Educational resources and tools</li>
              </ul>
              <p className="text-gray-700 leading-relaxed">
                We act as an intermediary platform and do not directly provide relocation services. Service providers listed on our platform are independent businesses.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-3xl font-bold text-[#0A381F] mb-4">3. User Accounts</h2>
              
              <h3 className="text-2xl font-bold text-[#0A381F] mb-3 mt-6">3.1 Account Creation</h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                To access certain features, you must create an account. You agree to:
              </p>
              <ul className="list-disc pl-6 mb-4 space-y-2 text-gray-700">
                <li>Provide accurate, current, and complete information</li>
                <li>Maintain and update your information to keep it accurate</li>
                <li>Maintain the security of your password</li>
                <li>Accept responsibility for all activities under your account</li>
                <li>Notify us immediately of any unauthorized use</li>
              </ul>

              <h3 className="text-2xl font-bold text-[#0A381F] mb-3 mt-6">3.2 Account Types</h3>
              <ul className="list-disc pl-6 mb-4 space-y-2 text-gray-700">
                <li><strong>Expat Accounts:</strong> For individuals relocating to Ireland</li>
                <li><strong>Service Provider Accounts:</strong> For businesses offering relocation services</li>
              </ul>

              <h3 className="text-2xl font-bold text-[#0A381F] mb-3 mt-6">3.3 Account Termination</h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                We reserve the right to suspend or terminate your account if you violate these Terms or engage in fraudulent, abusive, or illegal activities.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-3xl font-bold text-[#0A381F] mb-4">4. User Conduct</h2>
              <p className="text-gray-700 leading-relaxed mb-4">You agree not to:</p>
              <ul className="list-disc pl-6 mb-4 space-y-2 text-gray-700">
                <li>Violate any applicable laws or regulations</li>
                <li>Infringe on intellectual property rights</li>
                <li>Post false, misleading, or defamatory content</li>
                <li>Harass, threaten, or abuse other users</li>
                <li>Transmit viruses, malware, or harmful code</li>
                <li>Attempt to gain unauthorized access to our systems</li>
                <li>Use automated tools to scrape or collect data</li>
                <li>Impersonate others or misrepresent your affiliation</li>
                <li>Engage in spam or unsolicited marketing</li>
              </ul>
            </section>

            <section className="mb-12">
              <h2 className="text-3xl font-bold text-[#0A381F] mb-4">5. Service Provider Listings</h2>
              
              <h3 className="text-2xl font-bold text-[#0A381F] mb-3 mt-6">5.1 Verification Process</h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                We conduct reasonable verification of service providers, including business registration, licensing, and background checks. 
                However, we do not guarantee the quality, reliability, or legality of services provided by third parties.
              </p>

              <h3 className="text-2xl font-bold text-[#0A381F] mb-3 mt-6">5.2 Premium Listings</h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                Service providers may purchase premium listings for enhanced visibility. Premium status does not constitute an endorsement or guarantee of quality.
              </p>

              <h3 className="text-2xl font-bold text-[#0A381F] mb-3 mt-6">5.3 Reviews and Ratings</h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                Users may post reviews and ratings. We reserve the right to remove reviews that violate our content policies, including fake, defamatory, 
                or inappropriate content.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-3xl font-bold text-[#0A381F] mb-4">6. Payments and Subscriptions</h2>
              
              <h3 className="text-2xl font-bold text-[#0A381F] mb-3 mt-6">6.1 Pricing</h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                Service provider subscription fees are displayed on our pricing page. Prices are subject to change with 30 days' notice.
              </p>

              <h3 className="text-2xl font-bold text-[#0A381F] mb-3 mt-6">6.2 Payment Processing</h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                Payments are processed through Stripe. By providing payment information, you authorize us to charge your payment method for applicable fees.
              </p>

              <h3 className="text-2xl font-bold text-[#0A381F] mb-3 mt-6">6.3 Refund Policy</h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                We offer a 14-day free trial for premium subscriptions. After the trial period, subscriptions are non-refundable except as required by law. 
                You may cancel your subscription at any time, effective at the end of the current billing period.
              </p>

              <h3 className="text-2xl font-bold text-[#0A381F] mb-3 mt-6">6.4 Automatic Renewal</h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                Subscriptions automatically renew unless canceled before the renewal date. You will be charged the then-current subscription fee.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-3xl font-bold text-[#0A381F] mb-4">7. Intellectual Property</h2>
              
              <h3 className="text-2xl font-bold text-[#0A381F] mb-3 mt-6">7.1 Our Content</h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                All content on MoveToIreland.us, including text, graphics, logos, images, and software, is our property or that of our licensors and is protected by copyright, 
                trademark, and other intellectual property laws.
              </p>

              <h3 className="text-2xl font-bold text-[#0A381F] mb-3 mt-6">7.2 User Content</h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                By posting content on our platform, you grant us a non-exclusive, worldwide, royalty-free license to use, reproduce, modify, and display your content 
                in connection with our services.
              </p>

              <h3 className="text-2xl font-bold text-[#0A381F] mb-3 mt-6">7.3 Copyright Infringement</h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                If you believe content on our platform infringes your copyright, please contact us at copyright@movetoireland.us with details of the alleged infringement.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-3xl font-bold text-[#0A381F] mb-4">8. Disclaimers and Limitations of Liability</h2>
              
              <h3 className="text-2xl font-bold text-[#0A381F] mb-3 mt-6">8.1 No Warranty</h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                Our platform is provided "as is" without warranties of any kind, express or implied. We do not guarantee uninterrupted, error-free, or secure access.
              </p>

              <h3 className="text-2xl font-bold text-[#0A381F] mb-3 mt-6">8.2 Third-Party Services</h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                We are not responsible for the actions, services, or content of third-party service providers. Any transactions or interactions with service providers 
                are solely between you and them.
              </p>

              <h3 className="text-2xl font-bold text-[#0A381F] mb-3 mt-6">8.3 Limitation of Liability</h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                To the maximum extent permitted by law, MoveToIreland.us shall not be liable for any indirect, incidental, special, consequential, or punitive damages, 
                including loss of profits, data, or goodwill, arising from your use of our services.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-3xl font-bold text-[#0A381F] mb-4">9. Indemnification</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                You agree to indemnify and hold harmless MoveToIreland.us, its affiliates, and their respective officers, directors, employees, and agents from any claims, 
                damages, losses, liabilities, and expenses (including legal fees) arising from:
              </p>
              <ul className="list-disc pl-6 mb-4 space-y-2 text-gray-700">
                <li>Your use of our platform</li>
                <li>Your violation of these Terms</li>
                <li>Your violation of any rights of another party</li>
                <li>Your content posted on our platform</li>
              </ul>
            </section>

            <section className="mb-12">
              <h2 className="text-3xl font-bold text-[#0A381F] mb-4">10. Dispute Resolution</h2>
              
              <h3 className="text-2xl font-bold text-[#0A381F] mb-3 mt-6">10.1 Governing Law</h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                These Terms are governed by the laws of [Your Jurisdiction], without regard to conflict of law principles.
              </p>

              <h3 className="text-2xl font-bold text-[#0A381F] mb-3 mt-6">10.2 Arbitration</h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                Any disputes arising from these Terms or your use of our services shall be resolved through binding arbitration, except where prohibited by law.
              </p>

              <h3 className="text-2xl font-bold text-[#0A381F] mb-3 mt-6">10.3 Class Action Waiver</h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                You agree to resolve disputes on an individual basis and waive the right to participate in class actions or class arbitrations.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-3xl font-bold text-[#0A381F] mb-4">11. Privacy and Data Protection</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                Your use of our platform is also governed by our <Link to="/privacy" className="text-[#0A381F] hover:text-[#D4AF37] font-semibold cursor-pointer">Privacy Policy</Link>, 
                which explains how we collect, use, and protect your personal data in compliance with GDPR and other applicable laws.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-3xl font-bold text-[#0A381F] mb-4">12. Modifications to Terms</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                We reserve the right to modify these Terms at any time. We will notify you of material changes by:
              </p>
              <ul className="list-disc pl-6 mb-4 space-y-2 text-gray-700">
                <li>Posting the updated Terms with a new "Last Updated" date</li>
                <li>Sending email notifications to registered users</li>
                <li>Displaying a prominent notice on our platform</li>
              </ul>
              <p className="text-gray-700 leading-relaxed">
                Your continued use after changes become effective constitutes acceptance of the modified Terms.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-3xl font-bold text-[#0A381F] mb-4">13. Termination</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                We may terminate or suspend your access to our platform immediately, without prior notice, for any reason, including breach of these Terms. 
                Upon termination, your right to use our services ceases immediately.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-3xl font-bold text-[#0A381F] mb-4">14. Severability</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                If any provision of these Terms is found to be unenforceable or invalid, that provision shall be limited or eliminated to the minimum extent necessary, 
                and the remaining provisions shall remain in full force and effect.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-3xl font-bold text-[#0A381F] mb-4">15. Contact Information</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                For questions about these Terms, please contact us:
              </p>
              <div className="bg-[#0A381F] text-white rounded-xl p-8">
                <div className="grid md:grid-cols-2 gap-6">
                  <div>
                    <h4 className="font-bold mb-2 flex items-center gap-2">
                      <div className="w-5 h-5 flex items-center justify-center">
                        <i className="ri-mail-line text-xl"></i>
                      </div>
                      Email
                    </h4>
                    <p className="text-white/80">legal@movetoireland.us</p>
                  </div>
                  <div>
                    <h4 className="font-bold mb-2 flex items-center gap-2">
                      <div className="w-5 h-5 flex items-center justify-center">
                        <i className="ri-map-pin-line text-xl"></i>
                      </div>
                      Address
                    </h4>
                    <p className="text-white/80">[Your Business Address]</p>
                  </div>
                </div>
              </div>
            </section>
          </div>

          <div className="mt-12 pt-8 border-t border-gray-200">
            <div className="flex flex-wrap gap-4 justify-center">
              <Link 
                to="/privacy" 
                className="text-[#0A381F] hover:text-[#D4AF37] font-semibold cursor-pointer whitespace-nowrap"
              >
                Privacy Policy
              </Link>
              <span className="text-gray-400">•</span>
              <Link 
                to="/cookies" 
                className="text-[#0A381F] hover:text-[#D4AF37] font-semibold cursor-pointer whitespace-nowrap"
              >
                Cookie Policy
              </Link>
              <span className="text-gray-400">•</span>
              <Link 
                to="/" 
                className="text-[#0A381F] hover:text-[#D4AF37] font-semibold cursor-pointer whitespace-nowrap"
              >
                Back to Home
              </Link>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}
